
(function(template){
define('vue!basicComponents/serviceCounter',['Vue'],function(Vue){
    return {
        template: template,
        props: ['userId','count','itemid'],
        methods: {
            increment: function(e){
                e.stopPropagation();
               
                this.$emit('handle-Multiple-Click',this.userId,true)
            },
            decrement: function(e){
                e.stopPropagation();
                this.$store.commit('removeSingleService',{ userId:this.userId, id:this.itemid })
            }
        }
    }
})
})('<div class="service-counter"> <span v-if="count>1" @click="decrement" class="pointer">-</span> {{count}} <span class="pointer" @click="increment">+</span> </div>');
